import {DomainNameEnum} from '../../../../../provider/domain-config/domain-config-type';

export const domainEmails: Record<string, string> = {
    [DomainNameEnum.rocketData]: 'hello@rocketdata.io',
    [DomainNameEnum.twoGis]: 'helpdata@2gis.ru',
    [DomainNameEnum.brandWizard]: 'support@brandwizard.io',
};
